import { useLocation } from "react-router-dom";
import { useAuthEmailMutate } from "./service";
import useAlertStore from "store/alert";

export const useAuthEmail = () => {
  const { mutate } = useAuthEmailMutate();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { search } = useLocation();

  const onAuthEmail = () => {
    // 이메일 인증하기
    onSetAlert({
      isOpen: true,
      inner: "이메일인증을 진행하시겠습니까?",
      cnclBtn: true,
      onSetConfirm: () => {
        mutate({ certEncParam: search.replace("?param=", "") });
      },
    });
  };

  return {
    onAuthEmail,
  };
};
